import classNames from 'classnames';
import { HTMLAttributes } from 'react';

import './ChannelTag.scss';

interface Props extends HTMLAttributes<HTMLDivElement> {
  channel: string;
}

export const ChannelTag: React.FC<Props> = ({ channel, className, ...restProps }) => {
  return (
    <div {...restProps} className={classNames('custom-channel-tag', className)}>
      Замовлено в: {channel}
    </div>
  );
};
